module.exports = __webpack_public_path__ + "img/banner-1.681d9efd.jpg";